<template>
  <div class="container-fluid">
    <div class="row text-danger" v-if="itemNotInList">
      <h6>{{ $t('notOnYourList') }}</h6>
    </div>
    <div class="row justify-content-between">
      <div class="d-flex flex-column">
        <h3 class="font-weight-bold" v-if="!scanMode">
          {{ item.name
          }}<span class="alternate-name" v-if="item.alternateName">
            - {{ item.alternateName }}</span
          >
        </h3>
        <router-link v-else :to="{ path: `/i/${item.id}`, query: { scan: scanMode } }">
          <h3 class="font-weight-bold">
            {{ item.name
            }}<span class="alternate-name" v-if="item.alternateName">
              - {{ item.alternateName }}</span
            >
          </h3>
        </router-link>
        <h4 class="text-primary font-weight-bold">{{ item.brand }}</h4>
      </div>
      <WCProductPricing
        :item="item"
        :embeddedPrice="priceEmbeddedLineItem ? priceEmbeddedLineItem.embeddedPrice : null"
      ></WCProductPricing>
    </div>
  </div>
</template>

<script>
import WCProductPricing from '../WCProductPricing/WCProductPricing.vue';

export default {
  components: { WCProductPricing },
  props: {
    item: {
      type: Object,
      required: true,
    },
    scanMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    itemNotInList: {
      type: Boolean,
      default: false,
    },
    priceEmbeddedLineItem: {
      type: Object,
      required: false,
    },
  },
};
</script>
